export enum ArticlesActionType {
  FETCH_ARTICLES = 'FETCH_ARTICLES',
  SEARCH_ARTICLES = 'SEARCH_ARTICLES',
  FETCH_SELECTED_ARTICLE = 'FETCH_SELECTED_ARTICLE'
}
